var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "AddPicking",
    },
    [
      _c(
        "div",
        { staticClass: "AddPicking__top" },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 4 } },
            [
              _c("el-descriptions-item", { attrs: { label: "系统单号" } }, [
                _c("div", [_vm._v(_vm._s(_vm.pickingData.rsys))]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "检索单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容(选填)" },
                    model: {
                      value: _vm.pickingData.sretrieval,
                      callback: function ($$v) {
                        _vm.$set(_vm.pickingData, "sretrieval", $$v)
                      },
                      expression: "pickingData.sretrieval",
                    },
                  }),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                _c("div", [_vm._v(_vm._s(_vm.pickingData.order))]),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-descriptions",
            { attrs: { column: 4 } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: "出货门店" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        "filter-method": _vm.selectByStoreName,
                        disabled: "",
                      },
                      on: { change: _vm.checkStore },
                      model: {
                        value: _vm.storeInfo.sid,
                        callback: function ($$v) {
                          _vm.$set(_vm.storeInfo, "sid", $$v)
                        },
                        expression: "storeInfo.sid",
                      },
                    },
                    _vm._l(_vm.storeOptions, function (item) {
                      return _c("el-option", {
                        key: item.sid,
                        attrs: { label: item.cname, value: item.sid },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "门店地址" } }, [
                _c("div", { staticClass: "wHP" }, [
                  _vm._v(_vm._s(_vm.storeInfo.caddr)),
                ]),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex alignItemsCenter" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 4 } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单渠道" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pickingData.rchannel,
                            callback: function ($$v) {
                              _vm.$set(_vm.pickingData, "rchannel", $$v)
                            },
                            expression: "pickingData.rchannel",
                          },
                        },
                        _vm._l(_vm.channelOptions, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "顾客地址" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        model: {
                          value: _vm.pickingData.customerAddr,
                          callback: function ($$v) {
                            _vm.$set(_vm.pickingData, "customerAddr", $$v)
                          },
                          expression: "pickingData.customerAddr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "icon iconfont grey" }, [_vm._v("")]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex alignItemsCenter" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 4 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "销售组织" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.shopFinanceName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "销售门店" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.shopName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "库存组织" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.storeFinanceName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "出库门店" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.storeInfo.cname)),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 4 } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "单据状态" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容(选填)" },
                        model: {
                          value: _vm.pickingData.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.pickingData, "remarks", $$v)
                          },
                          expression: "pickingData.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "单据备注" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容(选填)" },
                        model: {
                          value: _vm.pickingData.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.pickingData, "remarks", $$v)
                          },
                          expression: "pickingData.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w200 flex",
                  staticStyle: { "justify-content": "flex-end" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: { click: _vm.openDeviceDialog },
                    },
                    [_vm._v("门店智控")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.meituanGiftList, function (item) {
            return _c(
              "div",
              { key: item.sid, staticClass: "flex" },
              [
                _c(
                  "el-descriptions",
                  { attrs: { column: 4 } },
                  [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "赠品信息" } },
                      [_vm._v(" " + _vm._s(item.sremark) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "w200 flex",
                    staticStyle: { "justify-content": "flex-end" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: { click: _vm.openDeviceDialog },
                      },
                      [_vm._v("门店智控")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c("el-collapse-item", { attrs: { title: "订单商品", name: "1" } }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.selectOrderTableData.length < 2,
                      type: "primary",
                      size: "mini",
                    },
                    on: { click: _vm.handleMergeChangeOrder },
                  },
                  [_vm._v("合并")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "h300 AddPicking__table" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: {
                      data: _vm.orderTableData,
                      "row-key": "sid",
                      height: "300",
                      size: "mini",
                      "header-cell-style": {
                        background: "#f5f7fa",
                        color: "#606266",
                      },
                      "row-style": _vm.handleInventoryRed,
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        align: "center",
                        selectable: _vm.handleOrderSelectable,
                        "reserve-selection": true,
                        width: "55",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "序号",
                        align: "center",
                        width: "50",
                        type: "index",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cgoodsSku",
                        align: "center",
                        label: "SKU",
                        width: "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "图片", align: "center", width: "70" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.cmasterUrl != null
                                ? _c("el-image", {
                                    staticClass: "w30 h30",
                                    attrs: {
                                      "preview-src-list": [
                                        scope.row.cmasterUrl,
                                      ],
                                      src: scope.row.cmasterUrl,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "商品编码",
                        align: "center",
                        width: "130",
                        prop: "cgoodsBarcode",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "商品名称",
                        align: "center",
                        prop: "cgoodsName",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "单位", align: "center", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "单价", align: "center", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  "￥ " + _vm._s(scope.row.dgoodsPrice / 100)
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "数量",
                        prop: "ngoodsNum",
                        align: "center",
                        width: "130",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "标注",
                        align: "center",
                        width: "130",
                        prop: "type",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.type === 1
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "blue" } },
                                    [_vm._v("常规品")]
                                  )
                                : scope.row.type === 2
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "right-end",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        _vm._l(scope.row.rows, function (item) {
                                          return _c("p", { key: item.sid }, [
                                            _vm._v(
                                              " " + _vm._s(item.cname) + " "
                                            ),
                                          ])
                                        }),
                                        0
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#f59a23" } },
                                        [_vm._v("虚拟品")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("未配置")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", align: "center", width: "130" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.changeOrderPick
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("已换")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        align: "center",
                        fixed: "right",
                        width: "55",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "red",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleChangeOrder(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("换品")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "flex alignItemsCenter marginTop10",
                staticStyle: { "justify-content": "space-between", flex: "1" },
              },
              [
                _c("div", [
                  _vm._v(" 共计 "),
                  _c("span", { staticClass: "blue" }, [
                    _vm._v(_vm._s(_vm.orderTableData.length) + "种"),
                  ]),
                  _vm._v(" 商品，数量"),
                  _c("span", { staticClass: "blue" }, [
                    _vm._v(_vm._s(_vm.orderTableData.length) + "件"),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-collapse-item",
            { attrs: { title: "拣货单货品", name: "2" } },
            [
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [_vm._v("加赠品")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "h450 AddPicking__table" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.pickTableData,
                        height: "400",
                        "header-cell-style": {
                          background: "#f5f7fa",
                          color: "#606266",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "序号",
                          align: "center",
                          width: "50",
                          type: "index",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "图片", align: "center", width: "70" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.cmasterUrl != null
                                  ? _c("el-image", {
                                      staticClass: "w50 h50",
                                      attrs: {
                                        "preview-src-list": [
                                          scope.row.cmasterUrl,
                                        ],
                                        src: scope.row.cmasterUrl,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "货品名称",
                          align: "left",
                          prop: "cname",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.cname,
                                      placement: "top-start",
                                    },
                                  },
                                  [_c("div", [_vm._v(_vm._s(scope.row.cname))])]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#909399" } },
                                      [_vm._v("SKU:")]
                                    ),
                                    _vm._v(_vm._s(scope.row.cremark)),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#909399" } },
                                      [_vm._v("条码: ")]
                                    ),
                                    _vm._v(_vm._s(scope.row.csku)),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "货品标签",
                          align: "center",
                          width: "50",
                          prop: "labels",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "单位",
                          align: "center",
                          width: "50",
                          prop: "cunit",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "单价", align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.nprice
                                  ? _c("div", [
                                      _vm._v("￥ " + _vm._s(scope.row.nrice)),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "库位",
                          align: "center",
                          width: "70",
                          prop: "c_num",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hHP wHP flex marginLeft10",
                                    staticStyle: {
                                      "white-space": "break-spaces",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleTakeoff(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.cwarehouse))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "数量",
                          align: "center",
                          width: "130",
                          prop: "num",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "可用库存",
                          align: "center",
                          width: "60",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hHP wHP flex marginLeft10",
                                    staticStyle: {
                                      "white-space": "break-spaces",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowSurplusDialog(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.navailable))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "标注", align: "center", width: "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.formatRemark(scope.row) === 1
                                  ? _c(
                                      "div",
                                      { staticStyle: { color: "green" } },
                                      [_vm._v("订单品")]
                                    )
                                  : _vm.formatRemark(scope.row) === 2
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        { staticStyle: { color: "#f59a23" } },
                                        [_vm._v("换货品")]
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOrderPickDetail(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _c(
                                      "div",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("赠送品")]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          align: "center",
                          fixed: "right",
                          width: "55",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.formatRemark(scope.row) === 2
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "blue",
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleReOrderChange(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重选")]
                                    )
                                  : _vm._e(),
                                _c("br"),
                                _vm.formatRemark(scope.row) !== 1
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "red",
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDel(scope.$index)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex alignItemsCenter marginTop10",
                  staticStyle: {
                    "justify-content": "space-between",
                    flex: "1",
                  },
                },
                [
                  _c("div", [
                    _vm._v(" 共计 "),
                    _c("span", { staticClass: "blue" }, [
                      _vm._v(
                        _vm._s(
                          _vm.pickTableData.length > 1
                            ? _vm.pickTableData.length - 1
                            : _vm.pickTableData.length
                        ) + "种"
                      ),
                    ]),
                    _vm._v(" 货品 "),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm.deviceDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "elDialog",
              attrs: {
                "close-on-click-modal": false,
                title: "查看门店智控",
                visible: _vm.deviceDialogVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.deviceDialogVisible = $event
                },
              },
            },
            [_c("deviceControl", { attrs: { "store-info": _vm.storeInfo } })],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "库存校正",
            visible: _vm.surplusDialog,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.surplusDialog = $event
            },
          },
        },
        [
          _c("surplusSheet", {
            attrs: { "picking-detail": _vm.pickingDetail },
            on: {
              handleSubmit: _vm.handleSurplusSheetSubmit,
              handleClose: _vm.handleClose,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "添加赠品",
            visible: _vm.dialogVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("inventOrderGoodsAdd", {
                attrs: { "select-store": { rstore: _vm.storeInfo.sid } },
                on: {
                  handleClose: _vm.handleClose,
                  handleChoose: _vm.handleChooseGiveGoods,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: _vm.changeOrderTitle,
            visible: _vm.changeOrderVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeOrderVisible = $event
            },
          },
        },
        [
          _vm.changeOrderVisible
            ? _c("changeOrder", {
                attrs: {
                  "select-order-table-data": _vm.selectOrderTableData,
                  "store-id": _vm.storeInfo.sid,
                },
                on: {
                  handleSubmit: _vm.handleOrderChangeSubmit,
                  handleClose: _vm.handleClose,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "换品详情",
            visible: _vm.orderPickVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderPickVisible = $event
            },
          },
        },
        [
          _vm.orderPickVisible
            ? _c("orderPickDetail", {
                attrs: {
                  "order-table-data": _vm.orderTableData,
                  "pick-table-data": _vm.pickTableData,
                  "order-detail-ids": _vm.orderDetailIds,
                },
                on: {
                  handleSubmit: _vm.handleOrderChangeSubmit,
                  handleClose: _vm.handleClose,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }